<template>
    <div  >
            <top-navbar></top-navbar>
    
    
             <div  class="mb-5  background_color " >
              

              <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/issuetracking/index">{{language[1]['Home']}}  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{language[128]['User Manual']}}<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Skrivbordsapplikation Manual </h6>


                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" " class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


             <div>

                <template>
                <div>
                  <PdfViewer style="width: 100%;" :pdfUrl="'/NACKA_SKRIVBORDSAPPLIKATION.pdf'" />
                </div>
              </template>

             </div> 



    




















   

    <!-- <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-sm btn-outline-primary  mb-1 font-size_def bdr-rad">{{language[52]['Create']}}</button>
    </div>
    </div> -->





                </div>
                </div>
          
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
      import PdfViewer from "../../components/PdfViewer.vue";
    
     
    
    
      export default {
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
            PdfViewer,
        },


        mounted(){

 
      },


        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            language:JSON.parse(authService.isLanguage()),
        total:0,
        selectedOption: null, // Store the selected option
        file: null,

        errors: {},
        mainscats:[],
        subcats:[],
        contractor:{},
       
      
           
          }
    
        },
       
        methods : {

          

   

     

    },
    
    }
    
    </script>

    <style scoped>

canvas {
  max-width: 600px;
  margin: 0 auto;
}

    </style>
    